import * as React from 'react';
import {autobind} from '@shopify/javascript-utilities/decorators';
import {renderReact} from 'hypernova-react';
import {ContentProps, SignUpModal} from 'components/SignUpModal';

interface State {
  mode: string;
}

class NavLoginModal extends React.PureComponent<ContentProps, State> {
  signUpModal: any;

  constructor(props: ContentProps) {
    super(props);
    this.state = {mode: 'login'};
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange);
    this.handleHashChange();
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  @autobind
  handleHashChange() {
    const hash = window.location.hash;

    if (hash === '#login') {
      this.setState({mode: 'login'});
      this.signUpModal.openModal();
    }

    if (hash === '#signup') {
      this.setState({mode: 'signup'});
      this.signUpModal.openModal();
    }
  }

  @autobind
  handleModalClose() {
    const url = window.location.pathname + window.location.search;
    history.pushState('', document.title, url);
  }

  render() {
    const {mode} = this.state;

    const signUpModalProps = {
      buttonClassNames: ['hide'],
      mode,
      onClose: this.handleModalClose,
      ref: (ref) => { this.signUpModal = ref; },
      ...this.props,
    };

    return <SignUpModal {...signUpModalProps} />;
  }
}

export default renderReact('NavLoginModal', NavLoginModal);
